import React, { useContext } from 'react';
import './InvoiceAmountStatus.css';
import { dashboardContext } from '../../../Dashboard';
import TextSkeleton from '../../../../../Components/Skeletons/TextSkeleton';
import CustomSkelton from '../../../../../Components/Skeletons/CustomSkelton';
import useScreenSize from '../../../../../utils/useScreenSize';
import { useNavigate } from 'react-router-dom';
import { hasPrivilege } from '../../../../../utils/privileges';
import { useSelector } from 'react-redux';

const InvoiceAmountStatus = () => {
    const navigate = useNavigate();
    const privileges = useSelector((state) => state?.privileges?.privileges)

    const { data, isLoading } = useContext(dashboardContext);
    const { width } = useScreenSize();

    // ---------------- NAVIGATION ---------------- //
    const handleViewNavigate = () => {
        navigate(`/finance/invoice/list`);
    };

    return (
        <div className="invoice-status-container">
            <div className='invoice-header'>
                <span className="invoice-status-title">{isLoading ? <TextSkeleton width='50%' fontSize='3rem' /> : `Invoiced Amount & Status`}</span>
                {isLoading ? <TextSkeleton width="100%" fontSize="3rem" /> :
                    hasPrivilege(privileges, "Finances", 21, 2) &&
                    <span className="viewAll" onClick={handleViewNavigate}>
                        View All
                    </span>}
            </div>
            <div className="invoice-status-summary">
                {isLoading ? (
                    <>
                        <CustomSkelton
                            height={90}
                            width={width > 600 ? '33%' : '100%'}
                        />
                        <CustomSkelton
                            height={90}
                            width={width > 600 ? '33%' : '100%'}
                        />
                        <CustomSkelton
                            height={90}
                            width={width > 600 ? '33%' : '100%'}
                        />
                    </>
                ) : (
                    <>
                        <div className="summary-card total">
                            <span className="summary-label">Total Invoices</span>
                            <span className="summary-amount">{data?.totalInvoices || 0}</span>
                        </div>

                        <div className="summary-card paid">
                            <span className="summary-label">Paid</span>
                            <span className="summary-amount">{data?.paidInvoices || 0}</span>
                        </div>

                        <div className="summary-card pending">
                            <span className="summary-label">Pending</span>
                            <span className="summary-amount">{data?.unpaidInvoices || 0}</span>
                        </div>
                    </>

                )}

            </div>

            <div className="invoice-status-Invoiced">
                {isLoading ? (

                    <div className="invoice-status-summary">
                        <CustomSkelton
                            height={40}
                            width={width > 600 ? '33%' : '100%'}
                        />
                        <CustomSkelton
                            height={40}
                            width={width > 600 ? '33%' : '100%'}
                        />

                        <CustomSkelton
                            height={40}
                            width={width > 600 ? '33%' : '100%'}
                        />
                    </div>

                ) : (
                    <div className="Invoiced-header">
                        <span>Invoice No.</span>
                        <span>Amount</span>
                        <span>Status</span>
                    </div>
                )}
                {
                    isLoading ? (
                        <div className="invoice-status-summary">
                            <CustomSkelton
                                height={40}
                                width={width > 600 ? '33%' : '100%'}
                            />
                            <CustomSkelton
                                height={40}
                                width={width > 600 ? '33%' : '100%'}
                            />

                            <CustomSkelton
                                height={40}
                                width={width > 600 ? '33%' : '100%'}
                            />
                        </div>
                    ) : data?.lastInvoiceswithWorksite?.length === 0 ? (
                        <div className="no-invoices">No Invoices Found</div>
                    ) : (
                        data?.lastInvoiceswithWorksite?.map((invoice, index) => (
                            <div className="Invoiced-row" key={index}>
                                <span className="bold">{invoice?.InvoiceNumber || `N/A`}</span>
                                <span>{invoice?.Amount || `N/A`}</span>
                                <span>
                                    <span className={`status-badge ${invoice?.Status?.toLowerCase() === `paid` ? invoice.Status.toLowerCase() : 'not-paid'}`}>
                                        ● {invoice.Status}
                                    </span>
                                </span>
                            </div>
                        ))
                    )
                }
            </div >
        </div >
    );
};

export default InvoiceAmountStatus;
